import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { Review } from '@app/models';

export interface ReviewApi {
  items: Review[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  private _reviewsRoute = '/api/reviews/';

  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpClient: HttpClient) { }

  getReviews(): Observable<any[]> {
    return this.httpClient.get<any[]>(this._reviewsRoute);
  }


  getUsersReviews(userId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(this._reviewsRoute + 'userReviews/' + userId);
  }


  getReviewSearchByPage(searchParams: any, curPage, itemsPerPage) {
    searchParams['selectAll'] = false;
    searchParams.sortField = 'reviewDate';
    searchParams.sortOrder = 'desc';
    searchParams.pageNumber = curPage;
    searchParams.pageSize = itemsPerPage;

    return this.httpClient.post<any>(this._reviewsRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
  }


  getOwnerReviews(ownerId: string): Observable<any> {
    return this.httpClient.get<any>(this._reviewsRoute + 'ownerReviews/' + ownerId);
  }


  getMaterialsReviews(materialId: string): Observable<any> {
    return this.httpClient.get<any>(this._reviewsRoute + 'materialReviews/' + materialId);
  }


  createReview(review: Review): Observable<any> {
    return this.httpClient.post<any>(this._reviewsRoute, JSON.stringify(review), this.headerOptions);
  }


  markDelete(id: string): Observable<any> {
    return this.httpClient.put(this._reviewsRoute + 'mark-deleted/' + id, this.headerOptions);
  }


  deleteReview(id: string): Observable<any> {
    return this.httpClient.delete(this._reviewsRoute + id);
  }
}